<template>
  <div class="animated fadeIn">
    <div :class="{ dimmed: true, none: !isSpinner }"></div>
    <div id="loading" :class="{ none: !isSpinner }">
      <div id="lod1"></div>
      <div id="lod2"></div>
      <div id="lod3"></div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "App",
  computed: mapGetters({
    isSpinner: "common/showSpinner"
  }),
  data() {
    return {};
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/App.vue